import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { ApiUrl } from './apiUrl';

export interface GlobalCategoryListData {
  categories: any[];
  tree: any[];
}

@Injectable({
  providedIn: 'root'
})
export class GlobalCategoryService {

  constructor(private api: ApiService) {}

  listCategories(params?: { status?: string; includeHidden?: string }): Observable<any> {
    let url = ApiUrl.globalCategories;
    if (params) {
      const qs = new URLSearchParams();
      if (params.status != null && params.status !== '') {
        qs.set('status', params.status);
      }
      if (params.includeHidden != null && params.includeHidden !== '') {
        qs.set('includeHidden', params.includeHidden);
      }
      const str = qs.toString();
      if (str) {
        url = `${url}?${str}`;
      }
    }
    return this.api.getRequest(url);
  }

  getCategory(id: string): Observable<any> {
    return this.api.getRequest(ApiUrl.globalCategoryById(id));
  }

  createCategory(body: any): Observable<any> {
    return this.api.postRequest(ApiUrl.globalCategories, body);
  }

  updateCategory(id: string, body: any): Observable<any> {
    return this.api.putRequest(ApiUrl.globalCategoryById(id), body);
  }

  deleteCategory(id: string): Observable<any> {
    return this.api.deletRequest(ApiUrl.globalCategoryById(id));
  }

  reorderCategories(items: { id: string; displayOrder: number }[]): Observable<any> {
    return this.api.putRequest(ApiUrl.globalCategoriesReorder, { items });
  }

  getStoreMappings(storeId: string): Observable<any> {
    return this.api.getRequest(ApiUrl.storeGlobalCategoryMappings(storeId));
  }

  putStoreMappings(storeId: string, mappings: { globalCategoryId: string; storeCategoryId: string | null | '' }[]): Observable<any> {
    return this.api.putRequest(ApiUrl.storeGlobalCategoryMappings(storeId), { mappings });
  }

  resolveStoreCategory(storeId: string, globalCategoryId?: string | null): Observable<any> {
    let url = ApiUrl.storeGlobalCategoryResolve(storeId);
    if (globalCategoryId) {
      url = `${url}?globalCategoryId=${encodeURIComponent(globalCategoryId)}`;
    }
    return this.api.getRequest(url);
  }

  /** Normalize list payload from standard API envelope. */
  extractListData(res: any): GlobalCategoryListData {
    const data = res?.response?.data ?? res?.data ?? {};
    return {
      categories: data.categories || [],
      tree: data.tree || []
    };
  }

  extractMappings(res: any): { globalCategoryId: string; storeCategoryId: string }[] {
    const data = res?.response?.data ?? res?.data ?? {};
    return data.mappings || [];
  }

  extractResolve(res: any): { storeCategoryId: string | null; source: string } {
    const data = res?.response?.data ?? res?.data ?? {};
    return {
      storeCategoryId: data.storeCategoryId ?? null,
      source: data.source || 'none'
    };
  }
}
